import React from 'react'
import Myfooter from "../../aboutus/aboutfooter/Aboutfooter"

const privacyfooter = () => {
    return (
        <div>
            <Myfooter />
            
        </div>
    )
}

export default privacyfooter
